import React, { useEffect } from 'react';
import SearchBar from '../searchBar/searchBar';
import { Link } from 'react-router5';
import {useTranslation} from "react-i18next";
import {Positions} from "../../grid/grid_panel";

function SetEntities({poi_entity, component_route}){
  // type will not be there w/ we are listing entities of themes (and not links)

  let contact_img;
  if(poi_entity.img === undefined || poi_entity.img === null){
    contact_img = <span className="c-contact_img-replace">{poi_entity.name[0].toUpperCase()}</span>
  }else{
    contact_img = <img alt="" className="c-contact_img" style={{width: "50px", height: "50px"}} src={poi_entity.img} />
  }

  return (
    <>
      <Link routeName={component_route} routeOptions={{reload: true}} routeParams={{id: poi_entity.id}}>
        <div className={`c-entities entities ${poi_entity.id}`}>
          {contact_img}
          <div className="c-infos">
            <div>{poi_entity.name}</div>
            {poi_entity.grid_node && <Positions node={poi_entity.grid_node} small={true} />}
          </div>
        </div>
      </Link>
    </>
  )
}

function SetReseaux({poi_contact, component_route}){
  // type will not be there w/ we are listing contacts of themes (and not links)
  let contact_img;
  if(poi_contact.img === undefined || poi_contact.img === null){
    contact_img = <span className="c-contact_img-replace">
      {poi_contact.firstname[0].toUpperCase()}{poi_contact.lastname[0].toUpperCase()}
    </span>
  }else{
    contact_img = <img alt="" className="c-contact_img" style={{width: "50px", height: "50px"}} src={poi_contact.img} />
  }

  return (
    <Link routeName={component_route} routeOptions={{reload: true}} routeParams={{id: poi_contact.id}}>
      <div className={`c-entities reseaux ${poi_contact.id}`}>
        {contact_img}
        <div className="c-infos">
          <div>{poi_contact.firstname} {poi_contact.lastname}</div>
          {poi_contact.grid_node && <Positions node={poi_contact.grid_node} small={true} />}
        </div>
      </div>
    </Link>
  )
}

function prepSearch(term) {
  return term.toUpperCase().replace('É','E');
}

function sortParticipants(data){
  return data.sort(function(a,b){
    // entity
    console.log("a", a);
    console.log("b", b);
    var nameA = prepSearch(a.type === "entity" ? a.name : a.firstname);
    var nameB = prepSearch(b.type === "entity" ? b.name : b.firstname);

    return nameA.localeCompare(nameB);
  });
}

function filterParticipants(participants, search) {
  if (search === "") return participants;

  search = prepSearch(search);

  return participants.filter(p => {
    const name = p.type === "entity" ? p.name : p.firstname + " " + p.lastname;
    return prepSearch(name).includes(search);
  });
}

function Participants({participants}){
  const { t } = useTranslation();
  const [search, setSearch] = React.useState("");

  const filtered = filterParticipants(participants, search);

  console.log(filtered);

  return <>
    <div className="c-container_search-bar">
      <SearchBar value={search} handleChange={(e) => setSearch(e.target.value)} />
    </div>
    { filtered.length === 0 && <p>{t('Aucun élément à afficher')}</p> }
    { filtered.length > 0 && filtered.map(e => {
      return (
	<div className="c-participant_list title" key={e.type + "_" + e.id}>
	  {
	    e.type == "entity"
	    ? <SetEntities poi_entity={e} component_route={"explore.entity"} />
	    : <SetReseaux poi_contact={e} component_route={"explore.contact"}/>
	  }
	</div>
      )
    })}
  </>
}

export {Participants, sortParticipants};
